import React from 'react';

import assertions from 'lib/assertions';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
import Row from 'components/Row';
import ToastActions from 'actions/ToastActions';
import { getReadableDeviceType, DeviceType } from 'auth/components/ConfirmDevice';

export type Props = {
  deviceType: DeviceType;
  uid: string;
  onSubmitCode: (uid: string, code: string) => Promise<void>;
};

export type State = {
  verifying: boolean;
  code?: string;
};

class ConfirmDeviceForm extends React.Component<Props, State> {
  state: State = {
    verifying: false,
    code: undefined,
  };

  continue = async () => {
    if (!this.state.code) {
      console.error('ConfirmDevice - missing verification code on continue');
      return;
    }

    this.setState({ verifying: true });

    try {
      await this.props.onSubmitCode(this.props.uid, this.state.code);
    } catch (err) {
      ToastActions.showErrorToast(
        `Error verifying your ${getReadableDeviceType(this.props.deviceType)}.`
      );
    } finally {
      this.setState({ verifying: false });
    }
  };

  render() {
    const { deviceType } = this.props;
    return (
      <>
        <form
          data-test="sign-in-form"
          onSubmit={e => {
            e.preventDefault();
            this.continue();
          }}>
          <Row size="small">
            <FormElement
              label="Confirmation code"
              element={Input}
              validate={e => {
                assertions.number(e.target.value, 'Must be a 4-digit numerical code');
                assertions.lengthEqualTo(e.target.value, 4, 'Must be a 4-digit numerical code');
              }}
              onValidChange={e => this.setState({ code: e.target.value })}
              onInvalidChange={() => this.setState({ code: undefined })}
              elementProps={{
                autofocus: true,
                placeholder: '0000',
                maxLength: 4,
                size: 'large',
                'data-test': 'confirm-input-box',
              }}
            />
          </Row>
          <Row size="medium">
            <Buttons axis="y">
              <Button
                disabled={!this.state.code || this.state.verifying}
                full
                data-test="submit-code-button"
                type="submit"
                eventKey={`log_in.confirm_${deviceType}_page.submit.click`}>
                Submit
              </Button>
            </Buttons>
          </Row>
        </form>
      </>
    );
  }
}

export default ConfirmDeviceForm;
